import { Alert, Stack } from "@mui/material";
import { Avatar, Text } from "@src/appV2/redesign/system/ui-components";

import { ShiftDetailInfo } from "./ShiftDetailInfo";

export interface ConfirmShiftTransfeeProps {
  shiftId: string;
  transfererName: string;
  transfererInitials: string;
  transfererProfileImageUrl: string | undefined;
}

export function ConfirmTransferee(props: ConfirmShiftTransfeeProps) {
  const { shiftId, transfererName, transfererInitials, transfererProfileImageUrl } = props;

  return (
    <Stack alignItems="center" spacing={7}>
      <Avatar src={transfererProfileImageUrl} fallbackText={transfererInitials} />
      <Text variant="h5">Accept {transfererName}&apos;s Transfer</Text>
      <Alert severity="warning" variant="filled">
        Are you sure you want to accept this transfer? It will be equivalent to booking the shift.
        If you cancel or No Call No Show, {transfererName} will lose 30 points. You CANNOT transfer
        this shift back or to someone else.
      </Alert>
      <ShiftDetailInfo shiftId={shiftId} />
    </Stack>
  );
}
